import { render, staticRenderFns } from "./PreguntaPuntoItemCard.vue?vue&type=template&id=0cd8cad4&scoped=true"
import script from "./PreguntaPuntoItemCard.vue?vue&type=script&lang=js"
export * from "./PreguntaPuntoItemCard.vue?vue&type=script&lang=js"
import style0 from "./PreguntaPuntoItemCard.vue?vue&type=style&index=0&id=0cd8cad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8cad4",
  null
  
)

export default component.exports